import Vue from 'vue'
import BookingTypeVuex from './BookingTypeVuex'
import BookingVuex from './BookingVuex'
import ConservationFeeVuex from './ConservationFeeVuex'
import DestinationVuex from './DestinationVuex'
import AutoVuex from './AutoVuex'
import DriverVuex from './DriverVuex'
import VehicleFee from './VehicleFee'
import PickUpLocation from './PickUpVuex'
import FacilityPricingType from './FacilityPricingType'
import NotesVuex from './NotesVuex'

Vue.mixin(BookingTypeVuex)
Vue.mixin(BookingVuex)
Vue.mixin(ConservationFeeVuex)
Vue.mixin(DestinationVuex)
Vue.mixin(AutoVuex)
Vue.mixin(DriverVuex)
Vue.mixin(VehicleFee)
Vue.mixin(PickUpLocation)
Vue.mixin(FacilityPricingType)
Vue.mixin(NotesVuex)
